import type { ReactNode } from 'react';
import { useDroppable } from '@dnd-kit/core';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';
import {
  encodeContainerId,
  pathsEqual,
} from '@/components/tree-dnd/tree-dnd-path';
import { useTreeDndHighlight } from '@/components/tree-dnd/tree-dnd-context';
import { cn } from '@/lib/utils';

interface TreeDndDroppableProps {
  path: NodePath;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

export function TreeDndDroppable({
  path,
  disabled,
  className,
  children,
}: TreeDndDroppableProps) {
  const highlightedContainerPath = useTreeDndHighlight();

  const { setNodeRef } = useDroppable({
    id: encodeContainerId(path),
    disabled,
  });

  const isHighlighted =
    highlightedContainerPath !== null &&
    pathsEqual(highlightedContainerPath, path);

  return (
    <div
      ref={setNodeRef}
      className={cn(
        className,
        isHighlighted &&
          'rounded-lg ring-2 ring-primary/40 ring-offset-2 ring-offset-background'
      )}
    >
      {children}
    </div>
  );
}
